import { MaterialService } from './material.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { Occurrence } from '../model/occurrence.model';
import { environment } from '../../../../environments/environment';
import { KiwixiService } from '../kiwixi/kiwixi.service';
import { Router } from '@angular/router';
import { KiwixiGlobals } from '../kiwixi/kiwixi.globals';
import { MailjetResponse } from '../model/mailjet.model';
@Injectable()
export class NotificationService extends KiwixiService {
  apiNotifications = environment.server + 'notifications/';

  constructor(
    private _http: HttpClient,
    private _router: Router,
    kiwixiGlobals: KiwixiGlobals,
    private materialService: MaterialService,
  ) {
    super(_http, _router, kiwixiGlobals, materialService);
  }

  getNotifications(params: HttpParams): Observable<any[]> {
    const header = this.createHttpClientAuthorizationHeader();
    return this._http.get<any[]>(this.apiNotifications, {
      headers: header,
      params: params,
    }).
      pipe(
        catchError(this.handleErrorObservable<any[]>(`getNotifications`))
      );
  }

  getNotificationById(notificationId: string): Observable<any> {
    const header = this.createHttpClientAuthorizationHeader();
    return this._http.get<any>(`${this.apiNotifications}${notificationId}/`, {
      headers: header,
    }).pipe(
      catchError(this.handleErrorObservable<any>(`getNotificationById id=${notificationId}`))
    );
  }

  patchNotifications(notificationId, param): Promise<Occurrence> {
    const notificationUrl = this.apiNotifications + notificationId + '/';
    const headers = this.createHttpClientAuthorizationHeader();
    return this._http.patch(notificationUrl, JSON.stringify(param), { headers: headers })
      .toPromise()
      .then((res: any) => res)
      .catch(error => {
        this.materialService.openSnackBar(`La mise à jour de la notification a échouée`, 'red');
        console.error('error patch occurrence service', error);
      })
  }

  getMailJetStatus(provider_message_id: string): Observable<MailjetResponse> {
    const header = this.createHttpClientAuthorizationHeader();
    return this._http.get<MailjetResponse>(this.apiNotifications + 'mailjet/' + provider_message_id + '/');
  }
}
